import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  return (
    <header className="sticky top-0 z-50 bg-white border-b border-gray-200 shadow-sm">
      <div className="max-w-[1600px] mx-auto px-6 sm:px-8 lg:px-12 h-16 flex items-center">
        {/* Logo - left aligned on both mobile and desktop */}
        <div className="flex items-center justify-start flex-grow md:flex-grow-0">
          <Link to="/" className="flex items-center mx-0">
            <div className="flex items-center">
              <img 
                src="/logo-dark-1.png" 
                alt="Us Inc logo" 
                className="h-8" 
              />
            </div>
          </Link>
        </div>
        
        {/* Mobile burger menu button - only visible on mobile, positioned on right */}
        <div className="md:hidden ml-auto">
          <button 
            className="text-gray-700 p-2 focus:outline-none"
            onClick={toggleMobileMenu}
            aria-label="Toggle menu"
          >
            <svg 
              xmlns="http://www.w3.org/2000/svg" 
              className="h-6 w-6" 
              fill="none" 
              viewBox="0 0 24 24" 
              stroke="currentColor"
            >
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth={2} 
                d="M4 6h16M4 12h16M4 18h16" 
              />
            </svg>
          </button>
        </div>

        {/* Empty flex space to push items right - hidden on mobile */}
        <div className="hidden md:block md:flex-1"></div>

        {/* Desktop Navigation - hidden on mobile */}
        <div className="hidden md:flex items-center space-x-6">
          <Link 
            to="/" 
            className="text-sm text-gray-800 font-medium hover:text-blue-600"
          >
            Home
          </Link>
          <span 
            className="text-sm text-gray-800 font-medium hover:text-blue-600 cursor-pointer"
          >
            Documentation
          </span>
          <button 
            className="px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 transition-colors ml-2"
          >
            Platform
          </button>
        </div>

        {/* Mobile menu - slide-out panel */}
        <div 
          className={`fixed inset-0 z-50 transform ${mobileMenuOpen ? 'translate-x-0' : '-translate-x-full'} transition-transform duration-300 ease-in-out md:hidden`}
        >
          {/* Overlay */}
          <div 
            className="absolute inset-0 bg-black bg-opacity-50"
            onClick={toggleMobileMenu}
          ></div>
          
          {/* Menu panel */}
          <div className="absolute inset-y-0 left-0 w-64 max-w-sm bg-white shadow-lg transform transition-transform duration-300 ease-in-out h-full">
            {/* Close button */}
            <div className="flex justify-end p-4">
              <button 
                className="text-gray-600"
                onClick={toggleMobileMenu}
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            
            {/* Mobile menu items */}
            <nav className="px-4 py-2">
              <ul className="space-y-6">
                <li>
                  <Link 
                    to="/"
                    className="block text-base font-medium text-gray-800 hover:text-blue-600"
                    onClick={toggleMobileMenu}
                  >
                    Home
                  </Link>
                </li>
                <li>
                  <span 
                    className="block text-base font-medium text-gray-800 hover:text-blue-600 cursor-pointer"
                    onClick={toggleMobileMenu}
                  >
                    Documentation
                  </span>
                </li>
                <li>
                  <button 
                    className="block text-base font-medium text-white hover:bg-blue-700 bg-blue-600 px-4 py-2 rounded-lg transition-colors w-full text-left"
                    onClick={toggleMobileMenu}
                  >
                    Platform
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
